import { useEffect, useState } from 'react';

import RefreshButton from '../../../../atoms/RefreshButton';
import { eventingApi } from '../../../../../services/eventingApi';
import { useApiResource } from '../hooks/useApiResource';
import { useRemainingHeight } from '../hooks/useRemainingHeight';
import ResourceState from '../shared/ResourceState';
import { Section } from '../shared/ui';
import QueueItem from './QueueItem';
import RedriveDialog from './RedriveDialog';
import { useRedrive } from './useRedrive';

const CARD_BOTTOM_GAP = 40;

interface QueuesTabProps {
  focusConsumer: string | null;
  onChanged: () => void;
}

const QueuesTab = ({ focusConsumer, onChanged }: QueuesTabProps) => {
  const queues = useApiResource(() => eventingApi.listDeadLetterQueues(), []);
  const [expanded, setExpanded] = useState<string | null>(focusConsumer);
  const { ref, height } = useRemainingHeight(CARD_BOTTOM_GAP);
  const { confirming, setConfirming, submitting, redrive } = useRedrive(() => {
    queues.reload();
    onChanged();
  });

  useEffect(() => setExpanded(focusConsumer), [focusConsumer]);

  return (
    <Section
      title="Filas e DLQs"
      subtitle="Mensagens que esgotaram as tentativas no consumidor. Abrir a DLQ não as tira da fila, mas conta como mais um recebimento (ApproximateReceiveCount)"
      actions={<RefreshButton variant="icon" label="as filas e DLQs" busy={queues.loading} onClick={queues.reload} />}
    >
      <div ref={ref} style={{ height }} className="space-y-3 overflow-y-auto" data-testid="queues-scroll">
        <ResourceState resource={queues} emptyText="Nenhum consumidor com DLQ configurada." />
        {(queues.data ?? []).map((queue) => (
          <QueueItem
            key={queue.consumer}
            queue={queue}
            expanded={expanded === queue.consumer}
            onToggle={() => setExpanded(expanded === queue.consumer ? null : queue.consumer)}
            onRedrive={() => setConfirming(queue)}
          />
        ))}
      </div>
      <RedriveDialog queue={confirming} submitting={submitting} onClose={() => setConfirming(null)} onConfirm={redrive} />
    </Section>
  );
};

export default QueuesTab;
